import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import * as ResourceApi from 'api/resources';
import BasicAccordion from "./BasicAccordion";
import DeleteResourceButton from "hoc/DeleteResourceButton";
import ResourceFormProxy from "classes/ResourceFormProxy";
import {createButtonSectionFactory, createButtonSectionFactoryWithAdditionalArgs} from "hoc/CreateButtonSection";
import {Icon} from 'semantic-ui-react';
import partial from 'lodash/partial';
import Config from 'Config';

class ResourceAccordion extends React.Component {
    state = {
        didScrollTo: false
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.openSection && !this.state.didScrollTo) {
            this.setState({didScrollTo: true});
            nextProps.toggleOpen(nextProps.openSection);
        }
    }

    render() {
        if (!this.props.formProxy.currentResource) {
            console.log('resource accordion currentResource is null', this.props);

            console.log(`sectionWrapper `, this.props.formProxy.sectionWrapper())
            try {
                
            } catch (e) {

            }

            // return "ResourceAccordion missing currentResource"
            // needs. formProxy={formProxy}
                                // field={field}
            const emulateProps = {
                ...this.props,
                field: this.props
            };
            // return createButtonSectionFactory(ResourceApi.Types.DropdownButton)(emulateProps)
            if (this.props.section && this.props.section.resourceType) {
                return createButtonSectionFactory(this.props.section.resourceType)(emulateProps)
            } else {
                console.log("speciy a section.resourceType in the config to include a create button")
            }
        }
        // console.log(`render `, this.props.formProxy.currentResource)

        try {
            let header;
            if (!this.props.innerHeader) {
                if (this.props.header) {
                    header = typeof(this.props.header) === "string" ? this.props.header : <this.props.header step={this.props.formProxy.currentResource}/>;
                } else {
                    header = <FormattedMessage id={this.props.headerKey}/>;
                }
            } else {
                header = <this.props.innerHeader bug={'that step param shoudnt be called step'} step={this.props.formProxy.currentResource} currentResource={this.props.formProxy.currentResource}/>
            }

            // console.log("resourceId", this.props.formProxy.currentResource.resourceId)

            return (
                <BasicAccordion id={this.props.sectionKey}
                                animate={this.props.animate}
                                validationStatus={this.props.hasError ? "error" : "active"}
                                headerIcon={this.props.specialType ?
                                <Icon
                                    name={(this.props.specialType === "answer" ? "check circle" : this.props.specialType + " circle")}/> : ""}
                                active={this.props.active}
                                index={this.props.index}
                                onClick={partial(this.props.toggleOpen, false) /* do not scroll when opening accordion */}
                                header={header}
                                className={this.props.className || ""}>
                {this.props.deletable === true ?
                    <div className="delete-button-wrapper">
                    <DeleteResourceButton formProxy={this.props.formProxy}
                                            section={this.props.section}
                                            deletableType={this.props.formProxy.currentResource.resourceId && this.props.formProxy.currentResource.resourceId.type}/>
                    </div>
                    : ""}
                {this.props.children}
                </BasicAccordion>
            );

        } catch(e) {
            console.log(e)
            return (`Error rendering this component: ${e.message}`)
        }

    }
}

ResourceAccordion.propTypes = {
    header: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.node.isRequired
    ]),
    headerKey: PropTypes.string,
    getHeaderKey: PropTypes.func,
    getClassName: PropTypes.func,
    innerHeaderKey: PropTypes.bool,
    getInnerHeader: PropTypes.func,
    active: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    deletable: PropTypes.bool,
    formProxy: PropTypes.instanceOf(ResourceFormProxy).isRequired,
    specialType: PropTypes.string,
    toggleOpen: PropTypes.func
};

ResourceAccordion.defaultProps = {
    deletable: false
};

export default ResourceAccordion;



// WEBPACK FOOTER //
// ./public/components/common/ResourceAccordion.jsx